import { createReducer, deleteIn, updateIn, isMatchId } from '../../helpers';
import { api } from '../../actions';

const initialState = {
    team: [],
};

export default createReducer(initialState, {
    [api.team.create.success]: (state, action) => {
        state.team.push(action.result);
    },
    [api.team.update.success]: (state, action) => {
        updateIn(state.team, isMatchId(action.memberId), action.result);
    },
    [api.team.delete.success]: (state, action) => {
        deleteIn(state.team, isMatchId(action.memberId));
    },
});
